$mol_icon_arrow_right_bold $mol_icon path \M4,15V9H12V4.16L19.84,12L12,19.84V15H4Z
